import { FooterContent } from "../FooterContent";
import { ContentWrapper } from "./ContentWrapper";

interface PageWrapperProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  showFooter?: boolean;
}

export const PageWrapper = ({ 
  style,
  showFooter = true,
  children, 
}: PageWrapperProps) => {
  return (
    <div style={style}>
      <ContentWrapper style={{ position: 'relative', zIndex: 2 }}>
        {children}
      </ContentWrapper>
      <div
        style={{
          backgroundColor: 'white',
          padding: '40px 10px',
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: -200,
            left: 0,
            right: 0,
            height: 400,
            background: 'linear-gradient(#eef1f4, #fff)',
          }}
        ></div>
        {showFooter && <FooterContent />}
      </div>
    </div>
  );
}; 